<script lang="ts">
    import { cn } from '$lib/utils/cn';

    import { onMount } from 'svelte';
    import DeviceDetector from 'svelte-device-detector';

    import { resolveWebinarStyling } from './_utils/resolveWebinarStyling';
    import Cta from './Cta.svelte';
    import Desktop from './Desktop.svelte';
    import { fetchVideoDetails } from './fetchVideoDetails';
    import Mobile from './Mobile.svelte';
    import Box from '../_wrappers/Box.svelte';

    import type { Language } from '$lib/types/Language';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let url = '';
    export let durationTrigger = 10;
    export let message = '';
    export let btnText = 'Click me!';
    export let theme: Theme | undefined = undefined;
    export let backgroundColor: string | undefined = undefined;
    export let color: string | undefined = undefined;
    export let onBtnClick: () => Promise<void> | void = () => {};
    export let onBtnMouseEnter: () => Promise<void> | void = () => {};
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let box = {};
    export let language: Language = 'en';

    // Video details
    let loading = true;
    let thumbnail = '';
    let ratio = 1;

    let ctaVisible = false;

    const styling = resolveWebinarStyling({ theme, backgroundColor, color });

    onMount(async () => {
        const videoDetails = await fetchVideoDetails(url);
        loading = false;

        thumbnail = videoDetails?.thumbnail || '';
        ratio = videoDetails?.ratio || 1;
    });

    const handleProgress = (progress: { playedSeconds: number }) => {
        if (progress.playedSeconds > durationTrigger) {
            ctaVisible = true;
        }
    };
</script>

<Box {id} {...box} {transitionDelay} {transitionEffect}>
    <div
        class={cn(
            styling.containerBorderRadiusClass,
            styling.shadowClass,
            styling.borderWidthClass,
            styling.borderStyleClass,
        )}
        style:border-color={styling.borderColor || null}
        style:overflow="hidden"
    >
        <DeviceDetector showInDevice="desktop">
            <Desktop
                {loading}
                {url}
                {btnText}
                btnBgColor={styling.buttonBgColor}
                btnColor={styling.buttonTextColor}
                {onBtnClick}
                {ctaVisible}
                {thumbnail}
                {language}
                onProgress={handleProgress}
                buttonBorderRadiusClass={styling.buttonBorderRadiusClass}
                containerBorderRadiusClass={styling.containerBorderRadiusClass}
            />
        </DeviceDetector>

        <DeviceDetector showInDevice="mobile">
            <Mobile
                {loading}
                {url}
                {btnText}
                btnBgColor={styling.buttonBgColor}
                btnColor={styling.buttonTextColor}
                {onBtnClick}
                {ctaVisible}
                {thumbnail}
                {language}
                ratio="{ratio}%"
                onProgress={handleProgress}
                buttonBorderRadiusClass={styling.buttonBorderRadiusClass}
                containerBorderRadiusClass={styling.containerBorderRadiusClass}
            />
        </DeviceDetector>

        <Cta
            {btnText}
            btnColor={styling.buttonTextColor}
            btnBgColor={styling.buttonBgColor}
            {ctaVisible}
            {message}
            {onBtnClick}
            {onBtnMouseEnter}
            containerBorderRadiusClass={styling.containerBorderRadiusClass}
            buttonBorderRadiusClass={styling.buttonBorderRadiusClass}
        />
    </div>
</Box>
